import { render, staticRenderFns } from "./SurroundingMarkets.vue?vue&type=template&id=0ce1a364&scoped=true"
import script from "./SurroundingMarkets.vue?vue&type=script&lang=js"
export * from "./SurroundingMarkets.vue?vue&type=script&lang=js"
import style0 from "./SurroundingMarkets.vue?vue&type=style&index=0&id=0ce1a364&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ce1a364",
  null
  
)

export default component.exports